import React from 'react';

const IcMenu = () => {
    return (
        <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M4 5.3002C4 4.83075 4.36461 4.4502 4.81437 4.4502H19.1856C19.6354 4.4502 20 4.83075 20 5.3002C20 5.76964 19.6354 6.1502 19.1856 6.1502H4.81437C4.36461 6.1502 4 5.76964 4 5.3002Z'
                fill='#333438'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M4 12.0004C4 11.5309 4.36461 11.1504 4.81437 11.1504H19.1856C19.6354 11.1504 20 11.5309 20 12.0004C20 12.4698 19.6354 12.8504 19.1856 12.8504H4.81437C4.36461 12.8504 4 12.4698 4 12.0004Z'
                fill='#333438'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M4 18.6996C4 18.2302 4.36461 17.8496 4.81437 17.8496H19.1856C19.6354 17.8496 20 18.2302 20 18.6996C20 19.1691 19.6354 19.5496 19.1856 19.5496H4.81437C4.36461 19.5496 4 19.1691 4 18.6996Z'
                fill='#333438'
            />
        </svg>
    );
};

export default IcMenu;
